<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="grid-view">
    <div v-show="currentOptStatus===optStatusDefs.normal" class="main-content">
      <search-item
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        :search-item-code="$t('Clearing.AccountStatements')"
        config-module="505"
        grid-config-module="190904"
        :auto-init="false"
        :is-append-query="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Clearing.QuickSearchReconciliationBillNumber')"
        @query="fetchData"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div v-if="currentOptStatus===optStatusDefs.normal" slot="operations">
          <el-button v-permission="['button_ACTBilling_editBillingGroup']" no="1" type="primary" @click="showBillGroupView(undefined,true,false)">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_ACTBilling_deleteBillingGroup']" no="2" type="danger" @click="deleteBillGroup()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-button v-permission="['button_ACTBilling_editBillingGroup']" no="3" type="primary" @click="showBillGroupView(undefined,true,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
          <el-button v-permission="['button_ACTBilling_confirmBillingGroup']" no="4" type="primary" @click="confirmBillGroup">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
          <el-button v-permission="['button_ACTBilling_unconfirmBillingGroup']" no="5" type="primary" @click="unConfirmBillGroup">{{ $t('CargoMsg.Cargo_CancelConfirm') }}</el-button>
          <!-- <el-button v-permission="['button_ACTBilling_printBillingGroup']" no="6" type="primary" @click="printBillingGroup">{{ $t('CargoMsg.Cargo_Print') }}</el-button> -->
          <el-dropdown
            v-permission="['button_ACTBilling_printBillingGroup']"
            no="6"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="printBillingGroup($t('CargoMsg.Cargo_Print'))"
            @command="printBillingGroup"
          >
            {{ $t('CargoMsg.Cargo_Print') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('Clearing.PrintAccordingAccountNumber')">{{ $t('Clearing.PrintAccordingAccountNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-if="role.createInvoiceFromBillingGroup || role.createInvoiceApFromBillingGroup" no="7" type="primary" @click="makeInvoiceEvent">{{ $t('CargoMsg.Cargo_Invoicing') }}/{{ $t('CargoMsg.Cargo_CollectInvoice') }}</el-button>
          <el-button v-permission="['button_ACTBilling_writeoffBillingGroup']" no="8" type="primary" @click="writeoffHandler">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
          <el-button v-permission="['button_ACTBilling_payauthBillingGroup']" no="9" type="primary" @click="doBillPayment">{{ $t('CargoMsg.Cargo_ApplyForPayment') }}</el-button>
          <el-tooltip type="primary" :content="$t('Billing.billing_recheckTip')" placement="bottom">
            <div class="btn" style="display: inline-block; margin-right: 5px;margin-left: 5px;">
              <el-button v-permission="['button_ACTBilling_recheck']" no="16" type="primary" @click="doRecheck">{{ $t('Billing.billing_recheck') }}</el-button>
            </div>
          </el-tooltip>
          <el-button v-permission="['button_ACTBilling_cancelRecheck']" no="17" type="primary" @click="doCancelRecheck">{{ $t('Billing.billing_cancelRecheck') }}</el-button>
          <!-- <el-button type="primary" @click="toAutomaticReconciliation">{{ $t('CargoMsg.AutomaticReconciliation') }}</el-button> -->
          <el-button v-permission="['button_ACTBilling_billingGroupBatchUpload']" type="primary" no="batchUpload" @click="batchUploadFileHandler">{{ $t('CargoMsg.Cargo_BatchUploadFile') }}</el-button>
          <el-button v-if="$checkPermission(['button_ACTBilling_billingGroupInvoicePool']) && searchConditions.paymentType === 0" type="primary" no="showInvoicePoolDialog" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}</el-button>
        </div>
        <template v-slot:searchAreaHeader>
          <div class="app-main-inner-row  extension-conditions-form">
            <el-form ref="basicForm" inline label-position="left">
              <el-form-item v-permission="['filter_ACTBilling_arBillingGroups','filter_ACTBilling_apBillingGroups','filter_ACTBilling_allBillingGroups']" :label="$t('CargoMsg.Cargo_PaymentReceiveMethodP')">
                <el-radio-group v-model="searchConditions.paymentType" no="10">
                  <el-radio v-permission="['filter_ACTBilling_arBillingGroups']" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                  <el-radio v-permission="['filter_ACTBilling_apBillingGroups']" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                  <el-radio v-permission="['filter_ACTBilling_allBillingGroups']" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-permission="['filter_ACTBilling_overseaBillingGroups','filter_ACTBilling_localBillingGroups']" :label="$t('CargoMsg.Cargo_BillOfType')">
                <el-radio-group v-model="searchConditions.chargeTypeGroup" no="11">
                  <el-radio v-permission="['filter_ACTBilling_localBillingGroups']" :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
                  <el-radio v-permission="['filter_ACTBilling_overseaBillingGroups']" :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="useOrderCenterMode" label-width="0">
                <el-checkbox v-model="searchConditions.internalCharge" no="12">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_StatementDateP')">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        no="13"
                        type="date"
                        style="width:100%;"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="1"><span style="font-size: 12px;">{{ $t('CargoMsg.Cargo_To') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        no="14"
                        type="date"
                        style="width:100%;"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" style="padding-left: 5px">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside" no="15">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="190904"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="dynamicColumnDefs"
          :sum-column-defs="sumColumnDefsComputed"
          :pre-column-state-callback="preColumnStateCallback"
          :row-data="rowData"
          :total-config="totalConfig"
          :show-row-groups="dataListDragGroup"
        />
      </div>
      <div id="footer-wrapper-tab-billing-group" class="pagination-wrapper">
        <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <span v-show="dataShow && totalAmountToCurrency.labelText" v-text="totalAmountToCurrency.labelText" />
          <span v-show="dataShow && totalAmountToCurrency.selectionCountLabel" v-text="totalAmountToCurrency.selectionCountLabel" />
          <charge-currency-total-group
            ref="chargeCurrencyTotalGroup1"
            :key="1"
            mode="group"
            :type="totalAmountToCurrency.type"
            :data-provider="totalAmountToCurrency.dataProvider"
            data-field="amount"
            :currency-field="totalAmountToCurrency.currencyField"
            :rate-field="totalAmountToCurrency.rateField"
            ar-field="ar"
            :arap-group="false"
            :show-wht="showWhtTax"
          />
        </div>
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="searchConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-show="!appendQuery"
          config-module="190904"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <!--对账单详情-->
    <bill-group-detail
      v-if="currentOptStatus===optStatusDefs.billGroupDetailView"
      view-source="billGroup"
      :billing-group-uuid="billingGroupUuid"
      :view-billing-group="viewBillingGroup"
      :location="location"
      :show-wht="showWhtTax"
      @backBillingGroupList="backBillingGroupList"
      @cancel="currentOptStatus=optStatusDefs.normal"
      @writeoffHandler="writeoffHandler"
    />
    <!--销账-->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :properties="properties" @writeoffSuccessHandler="reloadData" />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :open-sap-config="false"
      :visible.sync="showBillPaymentDialog"
      :create-submit="true"
      :location="location"
      step="step2"
      mode="overview"
      @cancel="cancelBillPayment"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="billGroup"
      :location="location"
      @reloadData="reloadData"
    />

    <!--    <make-invoice-dialog ref="invoice" />-->
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <!-- 云文件上传对话框 -->
    <batch-upload-file
      :visible.sync="cloudFile.visible"
      :redis-key="cloudFile.redisKey"
      :job-num="cloudFile.num"
      page-source="tabBillingGroup"
      :lob="cloudFile.lob"
    />

    <!-- 发票池弹窗 -->
    <invoice-pool-dialog
      v-if="invoicePoolDialog.visible"
      :visible.sync="invoicePoolDialog.visible"
      :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
      :selected-entities="invoicePoolDialog.selectedEntities"
      :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
      :operation="invoicePoolDialog.operation"
      :source="invoicePoolDialog.source"
    />

  </div>
</template>

<script>
import { DocumentManage, ensureExecuteSuccess } from '@/utils/commonUtil'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import BillDetail from './billDetail'
import billGroupDetail from './billGroupDetail'
import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import {
  batchDelBillingGroup,
  batchUnConfirmBillGroup,
  batchConfirmBillGroup,
  queryBillingByGroupId,
  hasAgentBillingForBillingGroup,
  batchReviewBillGroup
} from '@/api/clearing/billingNative'
import URL from '@/api/urlTranslator'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { cacheName, cache } from '@/utils/cacheManager'
import { getUserPrivileges } from '@/api/auth'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { Once } from '@/utils/commonUtil'
import TabBillingGroupHp from './tabBillingGroupHP'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import lodash from 'lodash'
import $store from '@/store'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { LOG_RECONCILIATION } from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { isNumber2 } from '@/utils/validate'
import batchUploadFile from '@/components/Cargo/Common/batchUploadFile.vue'
import { queryJobByChargeKeysFunc } from '@/api/clearing/charge'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import invoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog.vue'

export default {
  name: 'TabBillingGroup',
  components: { invoicePoolDialog, batchUploadFile, BillDetail, searchItem, billGroupDetail, BillPaymentDialog, writeOffDialog, makeInvoiceDialog, cargoTemplateSelectorDialog, ChargeCurrencyTotalGroup, cargoAgGridWrapper },
  data() {
    return {
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      allowTwoYearOutside: false,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      customSearchItems: [], // 自定义高级查询项
      documentManage: new DocumentManage(),
      showWriteOffDialog: false,
      showBillPaymentDialog: false,
      optStatusDefs: {
        billDetailView: 'billDetailView', // 账单详情页
        billGroupDetailView: 'billGroupDetailView', // 对账单详情页
        normal: 'normal'// 初始状态-无操作
      },
      currentOptStatus: 'normal',
      billType: 'charge',
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      defaultSearchItems: [],
      sumColumnDefs: [
        {
          field: 'amount',
          getValue: data => data.amount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        },
        {
          field: 'uninvoiceAmount',
          getValue: data => data.uninvoiceAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        },
        {
          field: 'verifiedAmount',
          getValue: data => data.verifiedAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      showSalePriceHc: false, // 显示销售单价hc权限：有此权限时隐藏核销金额，在created中异步赋值
      rowData: [],
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        paymentType: 1, // 账单收支类型
        advance: -1, //  是否垫付
        isNeedInvoice: -1, // 是否需要开票
        hasInvoice: -1, // 是否开票
        selectedEntitiesForHedging: [],
        chargeTypeGroup: 0, // 账单类型（国内/国外）
        billingGroupClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        exceptKeys: [], // 在查询中想要例外的对象列表
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: '',
        billingGroupStates: [], // 对账单状态
        billingGroupReviewStates: [], // 对账单状态
        billingGroupJobStates: [], // 业务状态
        billingGroupJobStateParam: 'BillingJobState',
        billingGroupRequires: ['writeoff', 'invoice'],
        internalCharge: false // 内结
      },
      billingGroupUuid: '',
      viewBillingGroup: true,
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 4 // 开票方式:3代表对账单
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: []
        }
      },
      showLoading: true, // 是否显示加载中样式
      totalAmountToCurrency: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        dataProvider: [], // 数据源
        dataField: 'amount',
        currencyField: 'currency',
        rateField: 'rate',
        type: 'auto',
        arapGroup: false,
        amountToCurrency: ''
      },
      once: new Once(this),
      viewSource: 'tabBillingGroup', //  页面请求发起方
      tabBillingGroupHp: new TabBillingGroupHp(this),
      showColumnsVisible: { // 控制显示列是否隐藏
        showInvoiceState: false,
        showRealClearingState: false,
        showVerifiedAmount: false,
        showFba: false,
        showUnInvoiceAmount: true
      },
      beforeConditions: null, // 记录上一次的查询条件，导出全部使用
      shouldFixed: false,
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      },
      writeOffDialog: { visible: false },
      role: {
        createInvoiceFromBillingGroup: false,
        createInvoiceApFromBillingGroup: false
      },
      cloudFile: {
        visible: false,
        lob: 'SE',
        num: 0,
        redisKey: ''
      },
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        operation: '',
        source: 'billingGroup',
        makeInvoiceMethod: 4
      },
      totalConfig: null,
      queryOfficeId: 0, // 记录查询时的分公司Id
      appendQuery: false, // 追加查询
      location: LOG_RECONCILIATION.code,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      billingHasPaidOff: false
    }
  },
  computed: {
    url() {
      return URL
    },
    dynamicColumnDefs() {
      const cols = this.tabBillingGroupHp.dynamicColumnDefs()
      // 有显示销售单价hc权限时隐藏核销金额列，并从设置列面板中移除
      if (this.showSalePriceHc) {
        cols.forEach(col => {
          if (col.field === 'verifiedAmount') {
            col.hide = true
            col.suppressColumnsToolPanel = true
          }
        })
      }
      return cols
    },
    // 合计列定义：有显示销售单价hc权限时过滤掉核销金额
    sumColumnDefsComputed() {
      if (this.showSalePriceHc) {
        return this.sumColumnDefs.filter(c => c.field !== 'verifiedAmount')
      }
      return this.sumColumnDefs
    },
    // 列状态预处理：有显示销售单价hc权限时强制隐藏核销金额，防止localStorage缓存覆盖
    preColumnStateCallback() {
      return columnState => {
        if (this.showSalePriceHc) {
          columnState.forEach(state => {
            if (state.colId === 'verifiedAmount') {
              state.hide = true
            }
          })
        }
        return columnState
      }
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    billType(newVal) {
    },
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Invoice.invoice_unlockBusinessDateQuery'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    rowData() {
      this.totalConfig = [
        lodash.cloneDeep({ ...this.$refs.chargeCurrencyTotalGroup1.chargeCurrencyTotalGroupData, label: '' })
      ]
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await this.tabBillingGroupHp.changeCustomSearchItems()
      }
    }
  },
  mounted() {
    this.scrollCallback()
    if (document.querySelector('.tab-billing-group')) {
      document.querySelector('.tab-billing-group').addEventListener('scroll', this.scrollCallback)
    }
  },
  async created() {
    // 显示销售单价hc权限：复数权限接口对管理员也返回真实配置，配置了该权限才隐藏
    const salePriceHcRes = await getUserPrivileges()
    const salePriceHcList = (salePriceHcRes && salePriceHcRes.data) || []
    this.showSalePriceHc = salePriceHcList.some(p => p.category === 'role' && p.shape === 'show_filed' && p.point === 'price')
    Object.assign(this.gridOptions, {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      onSelectionChanged: this.selectionChanged,
      onRowDoubleClicked: this.showBillGroupView,
      autoGroupColumnDef: {
        headerName: this.$t('Message.DataGroup'),
        field: 'autoColumn',
        minWidth: 220,
        comparator: (a, b) => {
          if (typeof a === 'string' && typeof b === 'string') {
            if (a && b) {
              const newA = a.replaceAll(',', '')
              const newB = b.replaceAll(',', '')
              if (isNumber2(newA) && isNumber2(newB)) {
                a = Number(newA)
                b = Number(newB)
              }
            }
            if (a && b && typeof a === 'number' && typeof b === 'number') {
              if (!isNaN(a) && !isNaN(b)) {
                return a - b
              }
            }
            for (let i = 0; i < a.length && i < b.length; ++i) {
              const aCode = a.charCodeAt(i)
              const bCode = b.charCodeAt(i)
              const diff = aCode >= 256 && bCode >= 256 ? a[i].localeCompare(b[i], 'zh') : aCode - bCode
              if (diff !== 0) {
                return diff
              }
            }
            return a.length - b.length
          }
          if (a === b) {
            return 0
          } else if (a < b) {
            return -1
          } else {
            return 1
          }
        }
      }
    })
    await cache.load(cacheName.CONFIG)
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    const defaultSearchFields = []
    const billingHasPaidOff = cache.config.get('BillingHasPaidOff')
    if (billingHasPaidOff) {
      const value = LoadDefaultQueryParam.getCheckBoxValue(billingHasPaidOff)
      if (value) {
        const searchField = new AdvancedSearchField()
        searchField.multiple = 0
        searchField.defaultValue = value
        searchField.itemLabel = 'Payment.wroteOffOrNot'
        searchField.itemName = 'charge.PAID_OFF'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.lock = true
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.action = 2
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
    }
    if (defaultSearchFields && defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
    }
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.tabBillingGroupHp.changeCustomSearchItems()
    this.role.createInvoiceFromBillingGroup = this.$checkPermission(['button_ACTBilling_createInvoiceFromBillingGroup']) // 开票权限
    this.role.createInvoiceApFromBillingGroup = this.$checkPermission(['button_ACTBilling_createInvoiceApFromBillingGroup']) // 收票权限
    this.searchConditions.billingGroupJobStates = LoadDefaultQueryParam.getConfigQueryParam(this.searchConditions.billingGroupJobStateParam, SystemConstants.JOB_STATES)
    this.searchConditions.billingGroupStates = LoadDefaultQueryParam.getConfigQueryParam('BillingGroupState', BillingConstants.BILLING_STATES)
  },
  beforeMount() {
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 跳转自动对账
    // toAutomaticReconciliation() {
    //   this.$router.push({ name: 'AutomaticReconciliation' })
    // },
    // 设置不可选日期范围
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 查询触发
    fetchData({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      this.tabBillingGroupHp.fetchData({ simpleTriggerMode, conditions })
    },
    // 分页触发查询
    fetchDataByPage() {
      this.showLoading = true
      this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
    },
    // 查看事件
    async toAdvQueryList(conditions, isUpdate = false) {
      const conditions_ = [...conditions]
      await this.tabBillingGroupHp.toAdvQueryList(conditions_, false, isUpdate)
    },
    // 编辑/查看对账单详情
    async showBillGroupView(event, needChecked, viewBillingGroup = true) {
      const self = this
      self.viewBillingGroup = viewBillingGroup
      if (needChecked) {
        const chooseRows = getGridSelected(self.gridOptions)
        if (chooseRows.length !== 1) {
          this.$message.warning(self.$t('common.tips.hasOneOnly'))
          return
        }
        if (chooseRows[0].branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(chooseRows[0].branchId)) {
          this.$message.warning(this.$t('Message.NoHasViewRole'))
          return
        }
        if (!viewBillingGroup) {
          if (chooseRows[0].state > BillingConstants.BILLING_NORMAL.code) {
            this.$message.warning(self.$t('act.billingGroup.hasConfirmed', [chooseRows[0].billingNo]))
            return
          }
          if (chooseRows[0].review === 1) {
            this.$message.warning(self.t('act.billingGroup.hasReviewed', [chooseRows[0].billingNo]))
            return false
          }
          if (await this.hasAgentBilling([chooseRows[0].uuid])) {
            this.$message.warning(self.$t('CargoMsg.Cargo_ContainsAgentBilling'))
            return
          }
        }
        self.billingGroupUuid = chooseRows[0].uuid
      } else {
        if (!event.data) {
          return
        }
        if (event.data.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(event.data.branchId)) {
          this.$message.warning(this.$t('Message.NoHasViewRole'))
          return
        }
        self.billingGroupUuid = event.data.uuid
      }
      self.currentOptStatus = self.optStatusDefs.billGroupDetailView
    },
    // 删除对账单
    async deleteBillGroup() {
      const self = this
      const chooseRows = getGridSelected(self.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(self.$t('act.billingGroup.selectedBillingGroup'))
        return
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }
      for (let i = 0; i < chooseRows.length; i++) {
        const billingGroup = chooseRows[i]
        if (billingGroup.state > 0) {
          this.$message.warning(this.$t('act.billingGroup.hasConfirmed', [billingGroup.billingNo]))
          return
        }
      }
      getGridSelectedIds(self.gridOptions, 'uuid').then(ids => {
        return this.$confirm(this.$t('act.billingGroup.confirmDelete', [ids.length]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          return batchDelBillingGroup(ids).then(res => {
            this.$message.success(this.$t('common.tips.deleteSuccess'))
            this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
          }).finally(() => {
          })
        }).catch(() => {
          // return Promise.reject('已取消删除')
        })
      }).catch(() => {
      })
    },
    // 确认对账单
    async confirmBillGroup() {
      console.log('确认对账', this.searchConditions.snapshotConditionsBillingGroup)
      const chooseRows = getGridSelected(this.gridOptions)
      const keys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const state = chooseRows[i].state
        if (state === 0) {
          keys.push({ 'key': chooseRows[i].uuid, 'version': chooseRows[i].version })
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }
      // 若对账单下存在未确认的账单
      let unConfirmed = false
      await queryBillingByGroupId(keys).then(res => {
        if (res && res.data) {
          chooseRows.forEach(item => {
            for (let i = 0; i < res.data.length; i++) {
              const bill = res.data[i]
              if (item.uuid === bill.billingGroupUuid && (!bill.confirmed || bill.confirmed === false)) {
                unConfirmed = true
                break
              }
            }
          })
        }
      })
      this.$confirm(this.$t('act.billingGroup.batchConfirmBillGroup', [keys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        // 若对账单下存在未确认的账单 则提示是否刷新对账单下的账单，确认 true 取消 false
        if (unConfirmed) {
          this.$confirm(this.$t('act.billingGroup.batchConfirmBill', [keys.length]), this.$t('common.tips.prompt'), {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            return batchConfirmBillGroup({ billingGroups: keys, billConfirm: true }).then(res => {
              this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
              this.$message.success(this.$t('act.billing.confirmSuccess'))
            })
          }).catch(action => {
            // 若状态为取消，则只确认对账单，不确认其下的账单
            if (action === 'cancel') {
              return batchConfirmBillGroup({ billingGroups: keys, billConfirm: false }).then(res => {
                this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
                this.$message.success(this.$t('act.billing.confirmSuccess'))
              })
            }
          })
        } else {
          // 对账单下不存在未确认的账单
          return batchConfirmBillGroup({ billingGroups: keys, billConfirm: true }).then(res => {
            this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
            this.$message.success(this.$t('act.billing.confirmSuccess'))
          })
        }
      }).catch(() => {
        // return Promise.reject('已取消确认')
      })
    },
    // 取消确认对账单
    async unConfirmBillGroup() {
      const chooseRows = getGridSelected(this.gridOptions)
      const keys = []
      let hasConfirmedBill = false // 是否有已确认的账单
      for (let i = 0; i < chooseRows.length; i++) {
        const state = chooseRows[i].state
        const review = chooseRows[i].review
        if (state === 1) {
          keys.push({ 'key': chooseRows[i].uuid, 'version': chooseRows[i].version })
          if (chooseRows[i].billingConfirmed) {
            hasConfirmedBill = true
          }
        }
        if (review === 1) {
          this.$message.warning(this.$t('act.billingGroup.noCancelConfirmBillGroup'))
          return
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }
      this.$confirm(this.$t('act.billing.confirmCancelBill', [keys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        let isCancelConfirmedBill = false
        // 判断对账单下是否存在已确认的账单
        await queryBillingByGroupId(keys).then(res => {
          if (res && res.data) {
            for (const bill of res.data) {
              if (bill.confirmed) {
                hasConfirmedBill = true
                break
              }
            }
          }
        })
        if (hasConfirmedBill) {
          isCancelConfirmedBill = await this.$confirm(this.$t('Billing.CancelConfirmedBillSameTime'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => true).catch(() => false)
        }
        return batchUnConfirmBillGroup(keys, isCancelConfirmedBill).then(res => {
          this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
          this.$message.success(this.$t('act.billing.cancelConfirmSuccess'))
        }).finally(() => {
          // this.fetchData()
        })
      }).catch(() => {
        // return Promise.reject('已取消取消确认')
      })
    },
    // 打印对账单
    async printBillingGroup(command) {
      const items = getGridSelected(this.gridOptions)
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
        return
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }
      const keyList = []
      for (const billingGroup of items) {
        keyList.push(billingGroup.uuid)
      }
      const multiplePrint = keyList.length > 1 && command === this.$t('Clearing.PrintAccordingAccountNumber') // 是否按照多个打印
      const params = {}
      params.BILLING_UUID = keyList
      params.printSource = DocumentConstants.BATCH_PRINT_DZD.code
      if (multiplePrint) {
        params.BILLING_UUID = keyList[0]
        params.multiplePrint = true
        params.multipleBillingUuid = keyList
      }
      // TemplateSelectorWin.getInstance().showThisWin(null, "GROUPBILLING", params, this);
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'GROUPBILLING'
      this.templateSelectorDialog.visible = true
    },
    // 对账单进行开票/收票
    async makeInvoiceEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('act.billingGroup.selectedBillingGroup'))
        return false
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }

      // 不允许“部分已开票 + 部分未开票”一起操作开票
      const mix = this.getInvoiceMixStatusFromBillingGroups(chooseRows)
      if (mix.hasInvoiced && mix.hasNotInvoiced) {
        this.$message.warning('勾选的对账单，存在已开票和未开票，不能一起开票')
        return
      }

      // 全部开票：直接打开发票详情（支持“上一张/下一张”翻看多张发票）
      if (mix.allFullInvoiced) {
        const opened = await this.openInvoiceDetailsByBillingGroups(chooseRows)
        if (!opened) {
          this.$message.error('打开发票详情失败')
        }
        return
      }

      const passThrough = await this.validateBillingGroup2Invoice(chooseRows)
      if (passThrough) {
        this.makeInvoiceProperties.isAr = this.searchConditions.paymentType === 1
        this.makeInvoiceProperties.isHedge = false
        this.makeInvoiceProperties.isSkipInvoiceFrom = false
        // 请求后台，返回开票界面的树状结构数据源以及相关基础属性
        await getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
          this.makeInvoiceProperties.keys = ids
        }).catch(() => {
        })
        this.makeInvoiceProperties.step = 'step1'
        this.makeInvoiceProperties.selectedEntities = chooseRows
        this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
      }
    },
    getInvoiceMixStatusFromBillingGroups(groups = []) {
      let hasInvoiced = false
      let hasNotInvoiced = false
      let allFullInvoiced = true
      for (const g of (groups || [])) {
        const state = Number(g ? g.invoiceState : BillingConstants.INVOICE_STATE_NOT_INVOICE.code)
        if (state === Number(BillingConstants.INVOICE_STATE_NOT_INVOICE.code)) {
          hasNotInvoiced = true
          allFullInvoiced = false
        } else {
          hasInvoiced = true
          if (state !== Number(BillingConstants.INVOICE_STATE_FULL.code)) {
            allFullInvoiced = false
          }
        }
      }
      return { hasInvoiced, hasNotInvoiced, allFullInvoiced }
    },
    async openInvoiceDetailsByBillingGroups(chooseRows) {
      const invoiceUuidSet = new Set()
      const addUuids = (raw) => {
        if (raw == null) return
        if (Array.isArray(raw)) {
          for (const it of raw) addUuids(it)
          return
        }
        String(raw)
          .split(/[\s,]+/)
          .map(s => String(s).trim())
          .filter(Boolean)
          .forEach(s => invoiceUuidSet.add(s))
      }

      for (const g of (chooseRows || [])) {
        if (!g) continue
        // 你这边约定：发票 key 统一在 groupInvoiceUuids，多个用逗号分隔
        addUuids(g.groupInvoiceUuids)
      }

      const invoiceUuids = Array.from(invoiceUuidSet).sort()
      if (invoiceUuids.length === 0) return false

      const MAX_OPEN_INVOICE_COUNT = 50
      if (invoiceUuids.length > MAX_OPEN_INVOICE_COUNT) {
        this.$message.warning(`匹配到${invoiceUuids.length}张发票，请缩小勾选范围后再查看`)
        return true
      }

      const invoiceRefRaw = this.$refs ? this.$refs.invoice : null
      const invoiceRef = Array.isArray(invoiceRefRaw) ? invoiceRefRaw[0] : invoiceRefRaw
      if (!invoiceRef || typeof invoiceRef.openInvoiceDetails !== 'function') {
        return false
      }
      try {
        await invoiceRef.openInvoiceDetails(invoiceUuids)
      } catch (e) {
        return false
      }
      return true
    },
    // 校验对账单是否符合开票要求
    async validateBillingGroup2Invoice(chooseRows) {
      await cache.load(cacheName.CONFIG)
      let ar = false
      let ap = false
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (billing.ar) {
          ar = true
        } else {
          ap = true
        }
      }
      // 有应收和应付费用 必须开票收票权限都有
      if (ar && ap && (!this.role.createInvoiceFromBillingGroup || !this.role.createInvoiceApFromBillingGroup)) {
        let d = this.$t('CargoMsg.Cargo_CollectInvoice')
        if (this.role.createInvoiceFromBillingGroup) {
          d = this.$t('CargoMsg.Cargo_Invoicing')
        }
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip2', [d]))
        return
      } else if (ar && !this.role.createInvoiceFromBillingGroup) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_CollectInvoice')]))
        return
      } else if (ap && !this.role.createInvoiceApFromBillingGroup) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_Invoicing')]))
        return
      }
      const InvoiceBillingGroupState = cache.config.get('InvoiceBillingGroupState')
      if (InvoiceBillingGroupState) {
        const InvoiceBillingGroupStateArray = InvoiceBillingGroupState.split(',')
        const billingStates = []
        if (InvoiceBillingGroupStateArray) {
          for (const state of InvoiceBillingGroupStateArray) {
            billingStates.push(parseInt(state))
          }
          let billingNoStr = ''
          for (let i = 0; i < chooseRows.length; i++) {
            const billing = chooseRows[i]
            if (!(((billing['state'] === 0 || billing['state'] === 1) && billingStates.indexOf(billing['state']) > -1) ||
              (billingStates.indexOf(2) > -1 && billing['review'] === 1) || (billingStates.indexOf(3) > -1 && billing['review'] === 0))) {
              billingNoStr = billingNoStr + billing['billingNo']
              if (i !== chooseRows.length - 1) {
                billingNoStr = billingNoStr + ','
              }
            }
          }
          if (billingNoStr) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SSNMIR'))
            return false
          }
        }
      }
      // 校验分公司是否符合开票要求
      if (this.queryOfficeId !== $store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      return true
    },
    // 开票成功刷新列表
    reloadData() {
      this.showLoading = false
      this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup, true)
    },
    // 申请付款
    async doBillPayment() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
        return false
      }
      if (await this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainsAgentBilling'))
        return
      }
      if (this.queryOfficeId !== $store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      if (!ClearingUtils.isSameAccount(chooseRows)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      if (!(await ClearingUtils.checkCreateBillPaymentByBillingGroup(chooseRows))) return
      const charges = await ClearingUtils.createBillPaymentByBillingGroup(chooseRows, this.searchConditions.paymentType)
      if (charges && charges.length > 0) {
        this.showBillPaymentDialog = true
        this.$refs.billPayment.initBillPayment(charges)
      }
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 列表checkBox选中变更事件
    selectionChanged() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed && node.data) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrency.selectionCountLabel = this.$t('CargoMsg.Cargo_ChooseP', [selections.length])
        this.totalAmountToCurrency.dataProvider = selections
      } else if (arg === 1) {
        this.totalAmountToCurrency.selectionCountLabel = ''
        this.totalAmountToCurrency.dataProvider = selections
      } else {
        this.totalAmountToCurrency.selectionCountLabel = ''
        this.totalAmountToCurrency.dataProvider = this.rowData
      }
    },
    // 返回对账单列表
    backBillingGroupList(billingGroup) {
      this.currentOptStatus = this.optStatusDefs.normal
      const rowData = this.rowData
      if (billingGroup && rowData && rowData.length > 0) {
        for (const item of rowData) {
          if (item.uuid === billingGroup.uuid) {
            Object.assign(item, billingGroup)
          }
        }
      }
      const tempRowData = rowData
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
      // this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.tab-billing-group')
        const footer = document.getElementById('footer-wrapper-tab-billing-group')
        if (container && footer) {
          const containerHeight = container.clientHeight - footer.offsetHeight
          const offset = footer.offsetTop - container.scrollTop
          if (offset > containerHeight) {
            this.shouldFixed = true
          } else {
            this.shouldFixed = false
          }
        }
      })
    },
    // 销账
    writeoffHandler(param) {
      if (param === 'detail') {
        this.properties.selectedEntities = []
        for (const billingGroup of this.rowData) {
          if (billingGroup.uuid === this.billingGroupUuid) this.properties.selectedEntities.push(billingGroup)
        }
      } else {
        this.properties.selectedEntities = getGridSelected(this.gridOptions)
      }
      if (this.properties.selectedEntities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
        return
      }
      if (this.queryOfficeId !== $store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      this.properties.writeoffBillingGroupState = String(cache.config.get('WriteoffBillingGroupState'))
      const writeoffBillingGroupState = []
      this.properties.writeoffBillingGroupState.split(',').forEach(function(value) {
        if (!isNaN(value) && value !== '') {
          writeoffBillingGroupState.push(Number(value))
        }
      })
      for (const item of this.properties.selectedEntities) {
        if (writeoffBillingGroupState.length > 0) {
          // writeoffBillingGroupState包含0、1时，根据state判断 包含2时显示已复核的对账单，writeoffBillingGroupState包含3时显示已复核的对账单
          if (!(((item.state === 0 || item.state === 1) && writeoffBillingGroupState.includes(item.state)) ||
            (writeoffBillingGroupState.includes(2) && item.review === 1) || (writeoffBillingGroupState.includes(3) && item.review === 0))) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SSNMWOR'))
            return
          }
        }
      }
      this.initEntities()
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      //
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.properties.isAr = this.properties.selectedEntities[0].ar
      this.properties.isEntitiesAr = this.properties.isAr
      this.properties.isOversea = false
      // if (this.searchConditions.chargeTypeGroup === 1) this.properties.defaultCurrency = 'USD'
      if (this.properties.selectedEntities[0].billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) this.properties.defaultCurrency = 'USD'
      this.properties.writeOffMode = 4 // 对账单
      this.properties.entities = []
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const billingTypeConfig = String(cache.config.get('billingType'))
      let queryAgentBillingCharge = false
      if (billingTypeConfig && billingTypeConfig.indexOf('2') > -1) {
        queryAgentBillingCharge = true
      }
      const requestBody = { 'keys': keys, 'classType': 'billingGroup', 'isOversea': this.properties.isOversea, 'queryAgentBillingCharge': queryAgentBillingCharge, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllSelectedSoaWrittenOff'))
        return
      }
      this.properties.accountId = this.properties.entities[0].accountId
      // 按对账单销账：未核销
      if (this.properties.writeOffMode === 4) {
        const billingGroupUuids = []
        for (const charge of this.properties.entities) {
          if (billingGroupUuids.indexOf(charge.billingGroupUuid) === -1) {
            billingGroupUuids.push(charge.billingGroupUuid)
          }
        }
        const selectedEntitiesNew = []
        for (const item of this.properties.selectedEntities) {
          if (billingGroupUuids.indexOf(item.uuid) !== -1) {
            selectedEntitiesNew.push(item)
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.currencys = []
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking()) {
        this.writeOffDialog.visible = true
      }
    },
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.ar) {
          return false
        }
      }
      return true
    },
    async hasAgentBilling(keys = []) {
      await cache.load(cacheName.CONFIG)
      let hasAgentBilling = false
      const billingTypeConfig = String(cache.config.get('billingType'))
      if (billingTypeConfig && billingTypeConfig.indexOf('2') > -1) {
        const chooseRows = getGridSelected(this.gridOptions)
        let keyList = []
        if (keys.length < 0) {
          keyList = keys
        } else {
          for (const billingGroup of chooseRows) {
            keyList.push(billingGroup.uuid)
          }
        }
        this.loading = getLoading()
        await hasAgentBillingForBillingGroup(keyList).then(res => {
          hasAgentBilling = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
      return hasAgentBilling
    },
    doRecheck() {
      const chooseRows = getGridSelected(this.gridOptions)
      const keys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const state = chooseRows[i].state
        const review = chooseRows[i].review
        if (state === 1 && review === 0) {
          keys.push(chooseRows[i].uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billingGroup.noRecheckBillGroup'))
        return
      }
      this.$confirm(this.$t('act.billingGroup.batchRecheckBillGroup', [keys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        batchReviewBillGroup(keys, 1).then(res => {
          this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
          this.$message.success(this.$t('act.billing.recheckSuccess'))
        })
      })
    },
    batchUploadFileHandler() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
        return
      }
      const loading = getLoading4Cxt(this)
      const data = {
        keys: chooseRows.map(row => row.uuid),
        anyStr: 'billingGroup'
      }
      queryJobByChargeKeysFunc(data).then(res => {
        if (!res.data || !res.data.redisKey) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
          return
        }
        if (res.data.multipleLob) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload2'))
          return
        }
        this.showCloudFile(res.data)
      }).finally(e => {
        loading.close()
      })
    },
    showCloudFile(data) {
      this.cloudFile.redisKey = data.redisKey
      this.cloudFile.lob = data.lob
      this.cloudFile.num = data.num
      this.cloudFile.visible = true
    },
    doCancelRecheck() {
      const chooseRows = getGridSelected(this.gridOptions)
      const keys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const review = chooseRows[i].review
        if (review === 1) {
          keys.push(chooseRows[i].uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billingGroup.noCancelRecheckBillGroup'))
        return
      }
      this.$confirm(this.$t('act.billingGroup.batchCancelRecheckBillGroup', [keys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        batchReviewBillGroup(keys, 0).then(res => {
          this.toAdvQueryList(this.searchConditions.snapshotConditionsBillingGroup)
          this.$message.success(this.$t('act.billing.cancelRecheckSuccess'))
        })
      })
    },
    showInvoicePoolDialog() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSoa'))
        return false
      }
      this.invoicePoolDialog.sellerTaxNameDefaultValue = chooseRows[0].title
      this.invoicePoolDialog.selectedEntities = chooseRows
      this.invoicePoolDialog.operation = 'collection'
      this.invoicePoolDialog.source = 'billingGroup'
      this.invoicePoolDialog.makeInvoiceMethod = 4
      this.invoicePoolDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
  #footer-wrapper-tab-billing-group {
    align-items: center;
    .fixedBottom {
      position: fixed;
      bottom: 0;
      right: 15px;
      background: #fff;
    }
  }
  .extension-conditions-form {
    .el-col {
      margin-top: 0!important;
    }
  }
</style>
